<!--<div class="editable" [class.editing]="editing" style="width:100%">
  <span class="editable-span" (click)="editing=true">
    {{text}}
  </span>
  <span *ngIf="!text||text.length==0"  style ="color:#ccc" class="editable-span" (click)="editing=true">
    {{defaultText}}
  </span>
  <div class="input-wrapper">
    <input type="text" autocomplete="false" minlength="20" [appFocus]="editing" [(ngModel)]="editStr" (blur)="onBlur($event)" (focus)="onFocus()"/>
  </div>
  
  <i class="fas fa-pen" (click)="editing=true"></i>
</div>-->
<div class="editInput">
	<a href="javascript:void(0)" class='editIcon' title="Edit" (click)="op.toggle($event);" [style.opacity]="disabled ? '0.5' : '1'" [style.cursor]="disabled ? 'not-allowed' : 'pointer'" [style.pointer-events]="disabled ? 'none' : 'auto'"><i class="fas fa-pen"></i></a>					
	<p-overlayPanel #op [appendTo]="'body'" [dismissable]="false" [showCloseIcon]="true"  [autoZIndex]="false" [baseZIndex]="1000" [style]="{'width': '440px'}">
        <ng-template pTemplate>
            <div style="margin:0; padding: 0; color:#C2D63F; max-height:100px; overflow:auto;"> 
				      <!--<input *ngIf="!max" type='search' class="editField" [(ngModel)]="editStr" autocomplete="false" placeholder="Input Here">
				      <input *ngIf="max" type='search' class="editField" [maxlength]="max" [(ngModel)]="editStr" autocomplete="false" placeholder="Input Here">-->
				      <textarea contenteditable data-wsc-autocreate="true"  *ngIf="!max" rows='3' type='search' class="editField" [(ngModel)]="editStr" autocomplete="false" placeholder="Input Here"></textarea>
				      <textarea contenteditable data-wsc-autocreate="true"  *ngIf="max" rows='3' type='search' class="editField" [maxlength]="max" [(ngModel)]="editStr" autocomplete="false" placeholder="Input Here"></textarea>
				      <br>
              <a *ngIf='isphotolog' href='javascript:void(0)' class="btn btn-outline-light btn-sm pt-0 pb-0 mr-3" (click)="endEdit('next'); op.hide()" >Save and to Next</a>
              <a href='javascript:void(0)' class="btn btn-outline-light btn-sm pt-0 pb-0 mr-3" (click)="endEdit(); op.hide()" >Save</a>
				      <a href='javascript:void(0)' class="mr-2" (click)="toUpper();" title="Uppercase" style="color:#C2D63F; font-weight:bold ">A</a>
				      <a href='javascript:void(0)' class="mr-2" (click)="toLower();" title="Lowercase" style="color:#C2D63F; font-weight:bold ">a</a>				
            </div>
		</ng-template>
    </p-overlayPanel>
</div>